import React, { useContext } from 'react';
import { getExpertiseWidgetStrategy } from 'widgets/expertise/ExpertiseWidgetStrategy';
import {
    ColumnPickerModal,
    PickableItem,
} from '@instinet-analytics/semantic-ui-components';
import AppContext from 'app/AppContext';
import { initialExpertiseConfiguration } from '../store/configuration/ExpertiseConfigurationState';
import { ExpertiseColumn } from 'widgets/expertise/ExpertiseColumnDefinitions';
import { useDispatchUpdateVisibleColumns } from 'widgets/store/grid/visibleColumns/dispatcher';
import { useWidgetContext } from 'widgets/WidgetContext';
import { useWidgetEditedColumnNames } from 'grid/columnNames/hooks';

export interface ExpertiseColumnPickerProps {
    visibleColumns: ExpertiseColumn[];
}

export default function ExpertiseColumnPicker(
    props: ExpertiseColumnPickerProps
) {
    const { visibleColumns } = props;
    const { widgetType } = useWidgetContext();
    const { buildColumnDefs } = getExpertiseWidgetStrategy(widgetType);
    const context = useContext(AppContext);
    const columnDefs = buildColumnDefs(context);
    const { editedColumnNames } = useWidgetEditedColumnNames();

    const allPickableItems: PickableItem<ExpertiseColumn>[] = columnDefs.map(
        (column) => ({
            value: column.colId! as ExpertiseColumn,
            name:
                (editedColumnNames ?? [])[column.colId!] ||
                column.headerName ||
                column.colId!,
            nameSuffix: (editedColumnNames ?? [])[column.colId!]
                ? column.headerName || column.colId!
                : undefined,
        })
    );

    const dispatchUpdateVisibleColumns = useDispatchUpdateVisibleColumns();

    const onUpdateVisibleColumns = (cols: ExpertiseColumn[]) => {
        dispatchUpdateVisibleColumns(cols);
    };

    return (
        <ColumnPickerModal
            selectedValues={visibleColumns}
            defaultSelectedValues={initialExpertiseConfiguration.visibleColumns}
            allItems={allPickableItems}
            hideGroupView={true}
            withoutDescriptions={true}
            onUpdateSelectedValues={onUpdateVisibleColumns}
        />
    );
}
